import { createSlice } from "@reduxjs/toolkit";
import {
  connectInstagram,
  createInstagramPost,
  updateInstagramPost,
  getInstagramPost,
  getInstagramPostDetails,
  deletePost,
  createInstagramStory,
} from "./thunk";

const initialState = {
  instagramData: [],
  instagramLoading: false,
  deleteLoading: false,
  error: null,
};

const instagramSlice = createSlice({
  name: "instagram",
  initialState,
  reducers: {
    resetInstagramData: (state) => {
      state.instagramLoading = false;
      state.instagramData = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------------------------------------------Connect instagram
      .addCase(connectInstagram.pending, (state) => {
        state.instagramLoading = true;
        state.error = null;
      })
      .addCase(connectInstagram.fulfilled, (state, action) => {
        state.instagramLoading = false;
        state.instagramData = action.payload;
      })
      .addCase(connectInstagram.rejected, (state, action) => {
        state.instagramLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Create post
      .addCase(createInstagramPost.pending, (state) => {
        state.instagramLoading = true;
        state.error = null;
      })
      .addCase(createInstagramPost.fulfilled, (state, action) => {
        state.instagramLoading = false;
        state.instagramData = action.payload;
      })
      .addCase(createInstagramPost.rejected, (state, action) => {
        state.instagramLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Create story
      .addCase(createInstagramStory.pending, (state) => {
        state.instagramLoading = true;
        state.error = null;
      })
      .addCase(createInstagramStory.fulfilled, (state, action) => {
        state.instagramLoading = false;
        state.instagramData = action.payload;
      })
      .addCase(createInstagramStory.rejected, (state, action) => {
        state.instagramLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Update post
      .addCase(updateInstagramPost.pending, (state) => {
        state.instagramLoading = true;
        state.error = null;
      })
      .addCase(updateInstagramPost.fulfilled, (state, action) => {
        state.instagramLoading = false;
        state.instagramData = action.payload;
      })
      .addCase(updateInstagramPost.rejected, (state, action) => {
        state.instagramLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get post
      .addCase(getInstagramPost.pending, (state) => {
        state.instagramLoading = true;
        state.error = null;
      })
      .addCase(getInstagramPost.fulfilled, (state, action) => {
        state.instagramLoading = false;
        state.instagramData = action.payload;
      })
      .addCase(getInstagramPost.rejected, (state, action) => {
        state.instagramLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------Get post details
      .addCase(getInstagramPostDetails.pending, (state) => {
        state.instagramLoading = true;
        state.error = null;
      })
      .addCase(getInstagramPostDetails.fulfilled, (state, action) => {
        state.instagramLoading = false;
        state.instagramData = action.payload;
      })
      .addCase(getInstagramPostDetails.rejected, (state, action) => {
        state.instagramLoading = false;
        state.error = action.payload;
      })
      // ------------------------------------------------------DElete post
      .addCase(deletePost.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
      })
      .addCase(deletePost.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.instagramData = action.payload;
      })
      .addCase(deletePost.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetInstagramData } = instagramSlice.actions;
export default instagramSlice.reducer;
